import React, { useCallback } from "react";
import _ from "lodash/fp";
import { useSelector } from "react-redux";
import useFetchCategories from "../components/useFetchCategories";
import { getCurrentDealer } from "../modules/dealers";
import { compose, setDisplayName } from "recompose";
import { withRouter } from "react-router-dom";
import Loading from "../components/Loading";
import TryAgain from "../components/TryAgain";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import useToggle from "../components/useToggle";
import cx from "classnames";

const getId = _.getOr("", "id");

const SelectCategoriesFormik = compose(
  setDisplayName("SelectCategory"),
  withRouter
)(
  ({
    form: { setFieldValue },
    field: { name, value },
    match: {
      params: { dealer_id }
    }
  }) => {
    const onSelectCategory = useCallback(
      category => () => {
        const isSelected = _.pipe(
          _.map(cat => cat.id),
          _.includes(category.id)
        )(value);
        const nextValues = isSelected
          ? _.reject(cat => cat.id === category.id, value)
          : [...value, category];
        setFieldValue(name, nextValues);
      },
      [name, setFieldValue, value]
    );
    const dealer = useSelector(getCurrentDealer);
    const dealerId = dealer_id || getId(dealer);
    const {
      loading,
      failure,
      fetchCategories,
      categories
    } = useFetchCategories({
      dealerId
    });

    const { toggle, isOpen } = useToggle();

    if (loading) {
      return <Loading label="Loading categories" />;
    }
    if (failure) {
      return <TryAgain label={failure} onTryAgain={fetchCategories} />;
    }
    return (
      <Dropdown toggle={toggle} isOpen={isOpen}>
        <DropdownToggle className="btn-simple" color="info" caret>
          Select Categories
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>Categories</DropdownItem>
          <DropdownItem divider />
          {_.map(category => {
            const isSelected = _.pipe(
              _.map(cat => cat.id),
              _.includes(category.id)
            )(value);
            const className = cx({ "text-info": isSelected });
            return (
              <DropdownItem
                className={className}
                key={getId(category)}
                onClick={onSelectCategory(category)}
              >
                {category.name}
              </DropdownItem>
            );
          }, categories)}
        </DropdownMenu>
      </Dropdown>
    );
  }
);

export default SelectCategoriesFormik;
